import styled from 'react-emotion'
import { color, menuWidth, z } from '../style'
import Label from './Label/Label'

export const Tooltip = styled(Label)({
  label: 'Tooltip',
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.2,
  background: color.black,
  color: 'white',
  minWidth: 30,
  maxWidth: menuWidth,
  height: 'auto',
  minHeight: 30,
  padding: '8px 10px',
  border: 'none',
  borderRadius: '2px !important',
  zIndex: z.tooltip,
  whiteSpace: 'normal',
  flexWrap: 'wrap',
  justifyContent: 'initial'
})

export default Tooltip
